import moment from "moment";
import "moment/locale/es";
import JsBarcode from "jsbarcode";

moment.locale("es");

const SIN_FECHA = "Sin fecha de entrega";

const importanciaLabel = (imp) => {
  switch (Number(imp)) {
    case 3: return "Alta";
    case 2: return "Media";
    case 1: return "Baja";
    default: return "-";
  }
};

const recortar = (texto) => {
  const t = (texto || "—").toString();
  return t.length > 120 ? t.slice(0, 120) + "…" : t;
};

const barcodeToDataUrl = (value) => {
  try {
    const v = (value || "").toString().trim();
    if (!v || v === "—") return null;

    const canvas = document.createElement("canvas");
    JsBarcode(canvas, v, {
      format: "CODE128",
      displayValue: false,
      height: 20,
      margin: 0,
      width: 1,
    });
    return canvas.toDataURL("image/png");
  } catch (e) {
    return null;
  }
};

const construirFilas = (insumos, catalogoInsumos, requisiciones) => {
  const reqMap = new Map((requisiciones || []).map((r) => [r._id, r]));

  return (insumos || [])
    .map((it) => {
      const cantidadPedida = Number(it?.cantidad) || 0;
      if (cantidadPedida <= 0) return null;

      const origenes =
        Array.isArray(it?.requisicionesOrigen) && it.requisicionesOrigen.length > 0
          ? it.requisicionesOrigen.map((o) => o.requisicionId)
          : it?.requisicionId
            ? [it.requisicionId]
            : [];

      const reqs = origenes.map((id) => reqMap.get(id)).filter(Boolean);
      const req = reqs[0] || null;

      const insumoFull = (catalogoInsumos || []).find((x) => x._id === it?.insumoId);

      const nombreInsumo =
        insumoFull?.descripcionInsumo ||
        insumoFull?.descripcion ||
        insumoFull?.nombre ||
        "—";

      const solicitante = req
        ? (
          (req?.solicitante?.nombre || "") +
          " " +
          (req?.solicitante?.apellidoPaterno || "") +
          " " +
          (req?.solicitante?.apellidoMaterno || "")
        ).trim()
        : "";

      return {
        separar: reqs.some((r) => !!r?.separarInsumos),

        requisicionNumero: reqs.map((r) => r.numero).join(", ") || "—",
        fechaSolicitud: req?.fechaSolicitud || null,
        solicitante: solicitante || "—",
        importanciaTxt: req ? importanciaLabel(req?.importancia) : "—",
        observacionesReq: req
          ? (req?.observaciones || req?.observacion || "").toString().trim() || "—"
          : "—",

        observacionesPartida: (it?.observaciones || "").toString().trim() || "—",
        fechaEntrega: it?.fechaEntrega || null,

        insumo: nombreInsumo,
        clave: insumoFull?.clave || insumoFull?.Clave || it?.clave || "—",
        codigoBarras:
          insumoFull?.codigoBarras ||
          insumoFull?.codigoDeBarras ||
          insumoFull?.barcode ||
          it?.codigoBarras ||
          "—",

        cantidad: cantidadPedida,
        unidad: it?.unidad || insumoFull?.unidad || "",

        clienteNombre: it?.clienteNombre || "—",
        pedidoNumero: it?.pedidoNumero || null,
      };
    })
    .filter(Boolean);
};

const definirColumnas = (simple, mostrarColumnaCliente) => {
  const columnas = [
    {
      header: "Clave",
      width: simple ? (mostrarColumnaCliente ? "8%" : "9%") : mostrarColumnaCliente ? "6%" : "6%",
      cell: (r) => ({ text: r.clave || "—", style: "td" }),
    },
    {
      header: "Insumo",
      width: simple ? (mostrarColumnaCliente ? "28%" : "34%") : mostrarColumnaCliente ? "17%" : "20%",
      cell: (r) => ({ text: r.insumo || "—", style: "td" }),
    },
    {
      header: "Cód. Barras",
      soloNormal: true,
      width: mostrarColumnaCliente ? "14%" : "15%",
      cell: (r) => {
        const img = barcodeToDataUrl(r.codigoBarras);
        const numero = (r.codigoBarras || "—").toString();
        if (!img) return { text: numero, style: "td" };
        return {
          stack: [
            { image: img, width: 80, alignment: "center", margin: [0, 1, 0, 1] },
            { text: numero, fontSize: 7, alignment: "center", margin: [0, 0, 0, 0] },
          ],
        };
      },
    },
    {
      header: "Cant.",
      alignment: "right",
      width: simple ? (mostrarColumnaCliente ? "6%" : "7%") : "5%",
      cell: (r) => ({ text: String(Number(r.cantidad) || 0), style: "td", alignment: "right" }),
    },
    {
      header: "Unidad",
      width: simple ? (mostrarColumnaCliente ? "6%" : "7%") : "5%",
      cell: (r) => ({ text: r.unidad || "—", style: "td" }),
    },
    {
      header: "Req.",
      width: simple ? (mostrarColumnaCliente ? "7%" : "8%") : "6%",
      cell: (r) => ({ text: r.requisicionNumero, style: "td" }),
    },
    {
      header: "Solicitante",
      soloNormal: true,
      width: mostrarColumnaCliente ? "10%" : "11%",
      cell: (r) => ({ text: r.solicitante, style: "td" }),
    },
    {
      header: "Fecha sol.",
      soloNormal: true,
      width: mostrarColumnaCliente ? "6%" : "7%",
      cell: (r) => ({
        text: r.fechaSolicitud ? moment(r.fechaSolicitud).format("DD/MM/YYYY") : "—",
        style: "td",
      }),
    },
    {
      header: "Import.",
      soloNormal: true,
      width: "5%",
      cell: (r) => ({ text: r.importanciaTxt, style: "td" }),
    },
    {
      header: "Obs. Req.",
      soloNormal: true,
      width: mostrarColumnaCliente ? "8%" : "9%",
      cell: (r) => ({ text: recortar(r.observacionesReq), style: "tdObs" }),
    },
    {
      header: "Observaciones",
      width: simple ? (mostrarColumnaCliente ? "30%" : "35%") : mostrarColumnaCliente ? "9%" : "11%",
      cell: (r) => ({ text: recortar(r.observacionesPartida), style: "tdObs" }),
    },
    {
      header: "Cliente",
      soloConCliente: true,
      width: simple ? "15%" : "9%",
      cell: (r) => ({
        stack: [
          { text: r.clienteNombre || "—", style: "td" },
          { text: "Pedido: " + (r.pedidoNumero || "—"), style: "tdSub" },
        ],
      }),
    },
  ];

  return columnas.filter(
    (c) => !(c.soloNormal && simple) && !(c.soloConCliente && !mostrarColumnaCliente)
  );
};

const agruparPorFecha = (filas) => {
  const porFecha = {};
  filas.forEach((r) => {
    const key = r.fechaEntrega
      ? moment(r.fechaEntrega).locale("es").format("L")
      : SIN_FECHA;
    if (!porFecha[key]) porFecha[key] = [];
    porFecha[key].push(r);
  });
  return porFecha;
};

const ordenarFechas = (fechas) =>
  fechas.sort((a, b) => {
    if (a === SIN_FECHA) return 1;
    if (b === SIN_FECHA) return -1;
    return moment(a, "L").valueOf() - moment(b, "L").valueOf();
  });

const SIN_CLIENTE = "—";

const agruparPorCliente = (filas) => {
  const porCliente = {};
  filas.forEach((r) => {
    const key = r.clienteNombre || SIN_CLIENTE;
    if (!porCliente[key]) porCliente[key] = [];
    porCliente[key].push(r);
  });
  return porCliente;
};

const ordenarClientes = (nombres) =>
  nombres.sort((a, b) => {
    if (a === SIN_CLIENTE) return 1;
    if (b === SIN_CLIENTE) return -1;
    return a.localeCompare(b, "es");
  });

const tablaLayout = {
  fillColor: (rowIndex) => {
    if (rowIndex === 0) return "#f0f0f0";
    return rowIndex % 2 === 0 ? "#fafafa" : null;
  },
  hLineColor: () => "#e0e0e0",
  vLineColor: () => "#e0e0e0",
  paddingLeft: () => 4,
  paddingRight: () => 4,
  paddingTop: () => 3,
  paddingBottom: () => 3,
};

const separacionInsumosPdf = ({
  orden,
  insumos,
  catalogoInsumos,
  requisiciones,
  simple,
  porCliente,
  porDia,
}) => {
  const filas = construirFilas(insumos, catalogoInsumos, requisiciones);
  if (!filas.length) return null;

  const separarRows = filas.filter((x) => x.separar);
  const noSepararRows = filas.filter((x) => !x.separar);

  const mostrarColumnaCliente = filas.some(
    (r) => (r.clienteNombre && r.clienteNombre !== "—") || r.pedidoNumero
  );

  const columnas = definirColumnas(!!simple, mostrarColumnaCliente);
  const widths = columnas.map((c) => c.width);
  const headerRow = columnas.map((c) => ({
    text: c.header,
    style: "th",
    ...(c.alignment ? { alignment: c.alignment } : {}),
  }));

  const construirTabla = (rows) => ({
    table: {
      headerRows: 1,
      widths,
      body: [headerRow.map((c) => ({ ...c })), ...rows.map((r) => columnas.map((c) => c.cell(r)))],
    },
    layout: tablaLayout,
  });

  const fechasDistintas = new Set(
    filas.map((r) => (r.fechaEntrega ? moment(r.fechaEntrega).locale("es").format("L") : SIN_FECHA))
  );
  const separarPorFecha = fechasDistintas.size > 1;

  let esPrimeraPagina = true;

  // Reglas de salto de hoja:
  // - solo "por día": una hoja por cada fecha, con todos los clientes corridos.
  // - solo "por cliente": una hoja por cada cliente; dentro de esa hoja, si el
  //   cliente tiene mas de una fecha, se separan con el mini encabezado de
  //   fecha pero SIN salto de hoja entre ellas.
  // - ambos: una hoja completa por cada combinación cliente + fecha.
  const construirBloqueAgrupado = (rows) => {
    const gruposCliente = porCliente ? agruparPorCliente(rows) : { [SIN_CLIENTE]: rows };
    const clientesOrdenados = porCliente ? ordenarClientes(Object.keys(gruposCliente)) : [SIN_CLIENTE];

    const content = [];
    clientesOrdenados.forEach((clienteKey) => {
      const filasCliente = gruposCliente[clienteKey];
      const gruposFecha = agruparPorFecha(filasCliente);
      const fechasOrdenadas = ordenarFechas(Object.keys(gruposFecha));

      fechasOrdenadas.forEach((fechaKey, idx) => {
        const esPrimeraFechaDelCliente = idx === 0;
        const necesitaSalto = porDia || (porCliente && esPrimeraFechaDelCliente);

        const encabezado = [];
        if (porCliente && (esPrimeraFechaDelCliente || porDia)) {
          encabezado.push({ text: `Cliente: ${clienteKey}`, style: "clienteHead" });
        }
        if (porDia || fechasOrdenadas.length > 1) {
          encabezado.push({ text: `Fecha de Entrega: ${fechaKey}`, style: "fecha" });
        }

        if (encabezado.length) {
          content.push({
            stack: encabezado,
            margin: [0, 8, 0, 6],
            ...(esPrimeraPagina || !necesitaSalto ? {} : { pageBreak: "before" }),
          });
        }
        esPrimeraPagina = false;
        content.push(construirTabla(gruposFecha[fechaKey]));
      });
    });

    return content;
  };

  const construirBloque = (rows) => {
    if (!rows.length) return [];

    if (porCliente || porDia) {
      return construirBloqueAgrupado(rows);
    }

    if (separarPorFecha) {
      const porFecha = agruparPorFecha(rows);
      return ordenarFechas(Object.keys(porFecha)).flatMap((fechaKey) => [
        { text: `Fecha de Entrega: ${fechaKey}`, style: "fecha" },
        construirTabla(porFecha[fechaKey]),
      ]);
    }

    return [construirTabla(rows)];
  };

  const ocFolio =
    (orden?.serieOrdenCompra ? orden.serieOrdenCompra + " - " : "") + (orden?.numero || "");

  const proveedorTxt =
    orden?.proveedor?.razonSocial ||
    (orden?.proveedor?.nombre
      ? `${orden?.proveedor?.nombre || ""} ${orden?.proveedor?.apellidoPaterno || ""} ${orden?.proveedor?.apellidoMaterno || ""}`.trim()
      : "—");

  return {
    pageSize: "LETTER",
    pageOrientation: "landscape",
    pageMargins: [22, 24, 22, 24],
    content: [
      { text: "SEPARACIÓN DE INSUMOS", style: "title" },
      {
        columns: [
          { text: `Orden de Compra: ${ocFolio}`, style: "sub", width: "33%" },
          { text: `Proyecto: ${orden?.proyecto?.nombre || "—"}`, style: "sub", width: "33%" },
          {
            text: `Fecha: ${moment().format("DD/MM/YYYY HH:mm")}`,
            style: "sub",
            width: "34%",
            alignment: "right",
          },
        ],
        margin: [0, 4, 0, 2],
      },
      { text: `Proveedor: ${proveedorTxt}`, style: "sub", margin: [0, 0, 0, 8] },
      ...construirBloque(separarRows),
      ...construirBloque(noSepararRows),
    ],
    styles: {
      title: { fontSize: 14, bold: true, alignment: "center" },
      clienteHead: { fontSize: 18, bold: true, margin: [0, 4, 0, 4] },
      fecha: { fontSize: 9, bold: true, margin: [0, 6, 0, 3] },
      sub: { fontSize: 9, color: "#555" },
      th: { fontSize: 9, bold: true },
      td: { fontSize: 8.5 },
      tdSub: { fontSize: 7.0, color: "#777", italics: true },
      tdObs: { fontSize: 7.0, color: "#333" },
    },
    defaultStyle: { fontSize: 9 },
  };
};

export default separacionInsumosPdf;
